import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableRootState, Langcodes } from '@uncinc/react-drupal-core/types';

import { ReactComponent as LogoSVG } from '../../../assets/images/nioz-logo.svg';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

interface LogoProps {
  className?: string;
  forceInverted?: boolean;
  toggleOverlay?: () => void;
}

const Logo: React.FC<LogoProps> = ({ className, forceInverted, toggleOverlay }) => {
  const { t } = useTranslation();

  const langcode = useSelector<ImmutableRootState<Langcodes>, Langcodes>((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const classes = c('Logo', className, {
    'Logo--inverted': forceInverted,
  });

  return (
    <CoreLink
      className={classes}
      href={`/${langcode}`}
      ariaLabel={t('menu.logo.aria_label')}
      onClick={() => toggleOverlay && toggleOverlay()}
    >
      <LogoSVG />
    </CoreLink>
  );
};

export default Logo;
